export default {
    position: 'bottom-right',
    inviteSize: 60,
    inviteImage: 'https://static.teclia.com/img/web_messenger/default_invite.png',
    inviteBottomMargin: 15,
    inviteSideMargin: 15,
    askForIdentification: true,
    baseDeConhecimento: null,
    microphoneEnabled: true,
    attachmentsEnabled: true,
    searchTitle: {
        html: '<div data-trix-wrapper>Descreva sua dúvida</div>',
        text: 'Descreva sua dúvida',
    },
    unavailableContent: {
        html:
            '<div data-trix-wrapper><strong>Não temos ninguém disponível no momento 😔</strong></div><div>Nosso horário de atendimento é das 08:30-12:00 e 13:15-17:00.</div>',
        text:
            'Não temos ninguém disponível no momento 😔\nNosso horário de atendimento é das 08:30-12:00 e 13:15-17:00',
    },
    firstMessageIntroduction: {
        html:
            '<div data-trix-wrapper><strong>👋 Olá, seja bem-vindo(a)!</strong></div><div>Como podemos te ajudar?</div>',
        text: '👋 Olá, seja bem-vindo(a)!\nComo podemos te ajudar?',
    },
    firstMessageOptions: [
        { text: 'Estou apenas navegando.' },
        { text: 'Eu gostaria de conhecer mais sobre vocês.' },
        { text: 'Eu sou um cliente com uma dúvida.' },
    ],
    homeTitle: 'Olá 👋',
    homeWelcomeMessage: 'Como podemos te ajudar?',
    primaryColor: '#4e00ff',
    chatDefaultAvatar: 'https://static.teclia.com/img/web_messenger/default_invite.png',
    chatDefaultHeaderTitle: 'Equipe de suporte',
    maxAmountOfActiveRooms: 2,

    /**
     * Depois que o atendimento for encerrado o widget deve dar a opção do usuário
     * voltar para home? Se não, uma mensagem de agradecimento é mostrada.
     */
    showThankYouMessageAfterClose: false,
    thankYouTitle: 'Atendimento finalizado',
    thankYouSubtitle: 'Muito obrigado por seu contato.',
    thankYouMessageAfterClose: 'Obrigado por entrar em contato.',
}
